const delSorting = {
    sortingTabs: [{
            sortingName: 'user',
            sortingAsc: 'deletion_intended_at',
            sortingDesc: '-deletion_intended_at',
            sortingAscTitle: 'Сначала старые',
            sortingDescTitle: 'Сначала новые'
        },
    ],
}

export default delSorting